import { render, staticRenderFns } from "./FakturPajakUserAccessAdd.vue?vue&type=template&id=11a5f171&scoped=true"
import script from "./FakturPajakUserAccessAdd.vue?vue&type=script&lang=js"
export * from "./FakturPajakUserAccessAdd.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakUserAccessAdd.vue?vue&type=style&index=0&id=11a5f171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a5f171",
  null
  
)

export default component.exports